export const isPlannedowntimeLog = (downtimeLog) => {
  if (
    typeof downtimeLog.comment === 'string' &&
    downtimeLog.comment.toLowerCase() === 'planned downtime'
  )
    return true;
  return false;
};
